import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importBankAccountAddContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "BankAccountAddContainer" */
                '@perpay-web/fintech/components/containers/BankAccountAddContainer'
            ),
    );
